import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import remindersRoutes from './reminders/reminders.routes';
import callCenterRoutes from './callCenter/callCenter.routes';
import deliveryUnknownRoutes from './settings/teletelDeliveryUnknown/teletelDeliveryUnknown.routes';
import AppContainer from './Dashboard.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...inboxRoutes,
        ...deliveryUnknownRoutes.routes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...remindersRoutes.routes,
        ...callCenterRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: () => import('./onboarding/Index.vue'),
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: () => import('./suspended/Index.vue'),
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: () => import('./noAccounts/Index.vue'),
    },
  ],
};
